<div [ngClass]="this.language == null || this.language === 'en' ? 'pre-login-en-css' : 'pre-login-other-css'">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-7 p-md-0 bg-alice">
                <app-main-sidebar></app-main-sidebar>
            </div>

            <div class="col-md-5">
                <div class="createPwdForm">
                    <h2 class="mt-3 mb-3"><strong>{{ "LOGIN.RESETPASSWORD" | translate}}</strong></h2>

                    <form [formGroup]="resetForm" class="q-addDeviceModal" (ngSubmit)="submit()">
                        <div class="form-div">

                            <div class="mt-2 mb-3 form-group">
                                <label class="q-form-label mb-1">{{ "SIGNUP.NAME" | translate}}</label>
                                <input type="text" readonly autocomplete="off" class="q-form-control form-control"
                                    formControlName="name" />
                            </div>

                            <div class="mt-2 mb-3 form-group">
                                <label class="q-form-label mb-1">{{ "SIGNUP.EmailId" | translate}}</label>
                                <div class="align-items-baseline">
                                    <input type="email" readonly autocomplete="off"
                                        class="q-form-control form-control pr-40" formControlName="email" />
                                </div>
                            </div>

                            <!-- New password -->
                            <div class="mt-2 mb-3 form-group">
                                <label class="mb-1 q-form-label">{{ "LOGIN.NEWPASSWORD" | translate}} <span
                                        class="text-danger">*</span></label>
                                <div class="dropdown info-dropdown cursor-pointer">
                                    <img [src]="'IMAGES.INFORMATIONIMG'|translate" alt="" class="ms-2" />
                                    <div class="dropdown-content">
                                        <div class="d-flex flex-column">
                                            <div class="fw-bold">
                                                {{ "LOGIN.PASSWORDCRITERIA" | translate }}
                                            </div>
                                            <div>1. {{ "LOGIN.PASSWORDCONTAINS" | translate }}</div>
                                            <div>
                                                2. {{ "LOGIN.PASSWORDSPECIALCHARACTER" | translate }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <input [type]="newPasswordVisible ? 'text' : 'password'" autocomplete="off"
                                        formControlName="password" class="q-form-control form-control pr-40"
                                        [ngClass]="{ 'is-invalid': f['password'].touched && f['password'].invalid }"
                                        placeholder="{{ 'LOGIN.ENTERNEWPASSWORD' | translate }}" />
                                    <div class="signup-showpwdIcon" (click)="toggleNewPwd()">
                                        <img [src]="'IMAGES.HIDEPWD'|translate" alt="" *ngIf="!newPasswordVisible" />
                                        <img [src]="'IMAGES.SHOWPWD'|translate" alt="" *ngIf="newPasswordVisible" />
                                    </div>
                                </div>
                                <div *ngIf="f['password'].touched && f['password'].errors" class="mw-340">
                                    <p class="errMessage">{{ "LOGIN.PASSWORDSPECIALCHARACTER" | translate }}</p>
                                </div>
                            </div>

                            <!-- Confirm password -->
                            <div class="mt-2 mb-3 form-group">
                                <label class="mb-1 q-form-label">{{ "LOGIN.CONFIRMPASSWORD" | translate }} <span
                                        class="text-danger">*</span></label>
                                <div class="dropdown info-dropdown cursor-pointer">
                                    <img [src]="'IMAGES.INFORMATIONIMG'|translate" alt="" class="ms-2" />
                                    <div class="dropdown-content">
                                        <div class="d-flex flex-column">
                                            <div class="fw-bold">
                                                {{ "LOGIN.PASSWORDCRITERIA" | translate }}
                                            </div>
                                            <div>1. {{ "LOGIN.PASSWORDCONTAINS" | translate }}</div>
                                            <div>
                                                2. {{ "LOGIN.PASSWORDSPECIALCHARACTER" | translate }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <input [type]="confirmPasswordVisible ? 'text' : 'password'" autocomplete="off"
                                        formControlName="confirmPassword" class="q-form-control form-control pr-40"
                                        [ngClass]="{ 'is-invalid':f['confirmPassword'].touched && f['confirmPassword'].invalid }"
                                        placeholder="{{ 'RESET_PASSWORD.CONFIRM_NEW_PASSWORD' | translate }}" />
                                    <div class="signup-showpwdIcon" (click)="toggleConfirmPwd()">
                                        <img [src]="'IMAGES.HIDEPWD'|translate" alt=""
                                            *ngIf="!confirmPasswordVisible" />
                                        <img [src]="'IMAGES.SHOWPWD'|translate" alt="" *ngIf="confirmPasswordVisible" />
                                    </div>
                                </div>
                                <ng-container
                                    *ngIf="errorMessage && (f['confirmPassword'].touched || f['password'].touched)">
                                    <p class="errMessage">{{ errorMessage }}</p>
                                </ng-container>
                            </div>

                            <div class="d-flex flex-column mt-3">
                                <div class="mb-3 w-100">
                                    <button type="submit" [disabled]="resetForm.invalid || loading"
                                        [ngClass]="resetForm.invalid ? 'q-invalid-button' : 'submit-btn bg-orgclr'">
                                        {{ loading
                                        ? ('RESET_PASSWORD.PLEASE_WAIT' | translate)
                                        : ('RESET_PASSWORD.RESET_PASS' | translate)
                                        }}
                                    </button>
                                </div>
                                <div class="w-100">
                                    <button type="button" class="cancel-btn bg-cancelbtn" routerLink="/">{{
                                        "LOGIN.CANCEL" | translate }}</button>
                                </div>
                            </div>
                        </div>
                    </form>


                </div>
            </div>
        </div>
    </div>
</div>